export default __webpack_public_path__ + "static/media/SM-Ex-2.753da7aa.png";